import PropTypes from 'prop-types';
import cn from 'classnames';

export default function LdsTabPanel({ activeTab, tabId, children }) {
  return (
    <div
      className={cn(
        'lds-tab',
        {
          active: activeTab === tabId,
        }
      )}
      id={`tab-panel-${tabId}`}
      aria-labelledby={`tab-btn-${tabId}`}
      role="tabpanel"
    >
      {children}
    </div>
  );
}

LdsTabPanel.propTypes = {
  activeTab: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  tabId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};
